import React, {Component} from 'react';
import UserOrderSlide from './user-order-slide';

class UserHomeTableOrders extends Component{

    

    render(){

        return(
           <div className="tab-pane fade show active" id="history" role="tabpanel">
               <div className="history-slider">
                    <div className="swiper-container history-slider-container">
                         <div className="swiper-wrapper">
                             <UserOrderSlide orderStudyNumber={"دراسة رقم 573"} orderStudyName={"دراسة جديدة"} orderStudyDate={"27/1/2021"} orderStudyStatus={"دراسة جديدة"}/>
                             <UserOrderSlide orderStudyNumber={"دراسة رقم 573"} orderStudyName={"دراسة جديدة"} orderStudyDate={"27/1/2021"} orderStudyStatus={"دراسة جديدة"}/>
                             <UserOrderSlide orderStudyNumber={"دراسة رقم 573"} orderStudyName={"دراسة جديدة"} orderStudyDate={"27/1/2021"} orderStudyStatus={"دراسة جديدة"}/>
                             <UserOrderSlide orderStudyNumber={"دراسة رقم 573"} orderStudyName={"دراسة جديدة"} orderStudyDate={"27/1/2021"} orderStudyStatus={"دراسة جديدة"}/>
                             <UserOrderSlide orderStudyNumber={"دراسة رقم 573"} orderStudyName={"دراسة جديدة"} orderStudyDate={"27/1/2021"} orderStudyStatus={"دراسة جديدة"}/>
                         </div>
                     </div>
                     <div className="text-center">
                        <a className="get-start-btn light-btn red-btn" href="/home/start">طلب جديد</a>
                        <a className="get-start-btn red-btn" href="/home">طباعة</a>
                     </div>
                </div>
            </div>
                        
            
        );
       
    }

};
export default UserHomeTableOrders;


